import React, { useState } from 'react';
import ContainerComponent from '../../helpers/components/container.component';
import MerchantSettlementLayout from './components/merchant_settlement_layout';
import { useLocation } from 'react-router-dom';

const MerchantSettlementIndex = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const [filter, setFilter] = useState({
        page : queryParams.get("page"),
        merchants : queryParams.get("merchants")?.split(',')?.map(Number)?.filter(x => x != 0),
        start_date : queryParams.get("start_date"),
        end_date : queryParams.get("end_date"),
    })
    return (
        <>
            <ContainerComponent span={22} top={20} bottom={20}>
                <MerchantSettlementLayout  default_filter={filter} />
            </ContainerComponent>
        </>
    );
}

export default MerchantSettlementIndex;